// extracted by mini-css-extract-plugin
export default {"rating":"CJ-z","numberOfStars":"DJ-z","count":"EJ-z","barGraphSpacing":"FJ-z","barGraph":"GJ-z"};